<div class="donutChart" [class.donutChart3]="showLabelValue">
  <div
    [id]="chartdiv_id"
    [class.donutChart2]="showCustomLegends"
    [class.donutChart5]="!showCustomLegends"
    [class.donutChart4]="showLabelValue"
  >
    @if(id){
    <div class="centered-label">
      <p>
        {{ overallNumber }}
        <span>SAR</span>
      </p>
      <span class="sub-title">{{ textInside }}</span>
    </div>
    }
  </div>
  @if(showCustomLegends){
  <div class="legends" [class.legend-with-values]="showLabelValue">
    @for(legend of data;track $index){ @if(legend.value > 0){
    <div class="legend">
      <div style="display: flex; gap: 5px; align-items: center">
        <span
          [ngStyle]="{
            background: legend.color
          }"
          class="legend-bullet"
          [class.bullet-val]="showLabelValue"
        ></span>
        <p>{{ legend.category }}</p>
      </div>

      @if(showLabelValue){
      <span>{{ legend.value }}</span>
      }
    </div>
    } }
  </div>
  }
</div>
